<script>
	import { subscription_info_store, pricings_store, user_store } from '../../stores.js';
    import { push, querystring } from 'svelte-spa-router';
    import { toast_message } from '../../utils/toast_message.js';


	let myself = {};
	let subscription_info = {};
	let pricing_info = {};
    let plan_type = '';

    subscription_info_store.subscribe(value => {
        subscription_info = value;
    });
    pricings_store.subscribe(value => {
        pricing_info = value;
    });
    user_store.subscribe(value => {
        myself = value;
        // plan_type = myself['plan_type'];
        // if (myself['is_authenticated']) {
        //     name = `${myself.first_name} ${myself.last_name}`;
        //     email = myself.email;
        // }
        // if (myself['is_subscribed'] !== undefined) {
        //     if (myself['is_subscribed']) {
        //         confirm_modal_show = false;
        //     } else {
        //         confirm_modal_show = true;
        //     }
        // }
    });

    const choose_plan = (_plan_type) => {
        plan_type = _plan_type;
        if (myself['is_authenticated']) {
            user_store.update(prev => {
                prev['plan_type'] = _plan_type;
                return prev;
            });
            push(`#/Contenthomepage${myself.is_trial ? '?trial' : ''}`);
        } else {
            let subdomain = '';
            const params = new URLSearchParams($querystring);
            if (params.has('domain_name')) {
                subdomain = params.get('domain_name');
            }
            if (!subdomain) {
                toast_message(false, 'Invalid domain name', 3000);
            }
            push(`#/Register_Plan?plan_type=${plan_type}&domain_name=${subdomain}`);
        }
    }
</script>


<div style='overflow-y: scroll;'>
	<h2>Grow Your Landscaping Business</h2>
    {#if subscription_info['basic'][0]}
	<div class='plan_container'>
		<div class='plan_card' style='background-color: transparent;'>
			<div class="kind">Basic</div>
			<div class="price">
				<span class="currency">$</span>
				<span class="price-number">{subscription_info['basic'][0]}</span>
				/ month
			</div>
			<!-- <div style="font-size: 15px;">billed yearly ($120 savings) or $29/month. No implementation fee</div> -->
			<button class='plan_button dark_plan' on:click={() => {choose_plan('basic')}}>{'Choose Plan'}</button>

			{#if pricing_info['plans']}
			<div class="price-card" style={`background-color: "#F1F4EF"}`}>
				<div style="font-size: 15px;">{pricing_info['plans'][0].bill}</div>
				<div class="description">{pricing_info['plans'][0].plan_content}</div>
				{#if (pricing_info['plans'][0].feature)}
					<div class="feature-title">{pricing_info['plans'][0].feature}</div>
				{/if}
				{#each pricing_info['plans'][0].able_services as able_service}
					<div class="item-container">
						<div class="key">{able_service.title}</div>
						{#each able_service.items as item}
							<div class="item">
								<div class="check-mark">
									<img src="/img/check.svg" alt="check" />
								</div>
								<div class="item-text">{item}</div>
							</div>
						{/each}
					</div>
				{/each}
			</div>
			{/if}
		</div>
		<div class='plan_card' style='background-color: transparent;'>
			<div class="kind">PRO</div>
			<div class="price">
				<span class="currency">$</span>
				<span class="price-number">{subscription_info['pro'][0]}</span>
				/ month
			</div>
			<!-- <div style="font-size: 15px;">billed yearly ($360 savings) or $129/month. No implementation fee</div> -->
			<button class='plan_button dark_plan' on:click={() => {choose_plan('pro')}}>{'Choose Plan'}</button>

			{#if pricing_info['plans']}
			<div class="price-card" style={`background-color: "#F1F4EF"}`}>
				<div style="font-size: 15px;">{pricing_info['plans'][1].bill}</div>
				<div class="description">{pricing_info['plans'][1].plan_content}</div>
				{#if (pricing_info['plans'][1].feature)}
					<div class="feature-title">{pricing_info['plans'][1].feature}</div>
				{/if}
				{#each pricing_info['plans'][1].able_services as able_service}
					<div class="item-container">
						<div class="key">{able_service.title}</div>
						{#each able_service.items as item}
							<div class="item">
								<div class="check-mark">
									<img src="/img/check.svg" alt="check" />
								</div>
								<div class="item-text">{item}</div>
							</div>
						{/each}
					</div>
				{/each}
			</div>
			{/if}
		</div>
		<div class='plan_card' style='background-color: #F1F4EF;'>
			<div class="kind">PRIME</div>
			<div class="price">
				<span class="currency">$</span>
				<span class="price-number">{subscription_info['prime'][0]}</span>
				/ month
			</div>
			<!-- <div style="font-size: 15px;">billed yearly ($600 savings) or $249/month. No implementation fee</div> -->
			<button class='plan_button' on:click={() => {choose_plan('prime')}}>{'Choose Plan'}</button>

			{#if pricing_info['plans']}
			<div class="price-card" style={`background-color: "#F1F4EF"}`}>
				<div style="font-size: 15px;">{pricing_info['plans'][2].bill}</div>
				<div class="description">{pricing_info['plans'][2].plan_content}</div>
				{#if (pricing_info['plans'][2].feature)}
					<div class="feature-title">{pricing_info['plans'][2].feature}</div>
				{/if}
				{#each pricing_info['plans'][2].able_services as able_service}
					<div class="item-container">
						<div class="key">{able_service.title}</div>
						{#each able_service.items as item}
							<div class="item">
								<div class="check-mark">
									<img src="/img/check.svg" alt="check" />
								</div>
								<div class="item-text">{item}</div>
							</div>
						{/each}
					</div>
				{/each}
			</div>
			{/if}
		</div>
	</div>
    {/if}
    <span class='contact_us'>If you have any questions about our plans, give us a call at 1-818-927-3458 or email hello@houseofyards.com</span>
</div>


<style>
    .contact_us {
        display: block;
        font-size: 15px;
        margin-top: 10px;
    }
    .price-card {
        margin: 20px 10px 10px 10px;
    }
    .kind {
        font-size: 15px;
        font-weight: 500;
    }
    .currency {
        font-weight: 700;
        margin-right: 10px;
        font-size: 18px;
    }
    .price-number {
        font-weight: 900;
        font-size: 52px;
        margin-right: 10px;
    }
    .price {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    .description {
        font-size: 18px;
        font-weight: 700;
        margin-top: 30px;
        line-height: 30px;
        min-height: 100px;
    }
    .choose :global(button) {
        width: 100%;
        color: white;
        margin: 30px 0;
        background-color: #222A1B;
    }
    .prime-choose :global(button) {
        width: 100%;
        margin: 30px 0;
    }
    .feature-title {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 40px;
    }
    .key {
        margin-bottom: 40px;
        padding-bottom: 15px;
        border-bottom: 1px solid #E5E5E7;
        font-weight: 700;
    }
    .item-container {
        margin-bottom: 40px;
    }
    .item {
        display: flex;
        margin-top: 20px;
    }
    .check-mark {
        width: 20px;
        height: 20px;
        display: contents;
        justify-content: center;
        align-items: center;
        background-color: #BCD570;
        border-radius: 100%;
    }
    .check-mark img {
        width: 12px;
    }
    .item-text {
        margin-left: 10px;
        font-size: 15px;
    }
    .plan_container {
        width: 100%;
        display: flex;
    }
    .plan_card {
        width: 33%;
        margin: 0px 5px;
        margin-top: 20px;
        padding: 10px;
    }
    .kind {
        font-size: 15px;
        font-weight: 500;
    }
    .currency {
        font-weight: 700;
        margin-right: 10px;
        font-size: 18px;
    }
    .price-number {
        font-weight: 900;
        font-size: 52px;
        margin-right: 10px;
    }
    .price {
        display: flex;
        align-items: center;
    }
    .plan_button {
        width: 100%;
        padding: 10px 20px;
        font-size: 16px;
        font-weight: 500;
        background-color: #BCD570;
        font-family: "Montserrat";
        border: none;
        outline: none;
        border-radius: 4px;
        color: #000;
        min-height: 45px;
        cursor: pointer;
        margin-top: 20px;
    }
    .plan_button.dark_plan {
        color: white;
        background-color: #222A1B;
    }
    @media (max-width: 800px) {
        .plan_container {
            display: block;
        }
        .plan_card {
            width: 100%;
            margin: 0px;
        }
    }
    .disabled {
        pointer-events: none;
        cursor: not-allowed;
        opacity: 0.8;
    }
</style>